import { render, staticRenderFns } from "./PersonOrganiztionlist.vue?vue&type=template&id=38db8ec3"
import script from "./PersonOrganiztionlist.vue?vue&type=script&lang=js"
export * from "./PersonOrganiztionlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports